<div class="c-form-field c-form-field--d">
  <p500-ui-select-field
    [formControl]="ctr"
    [data]="data"
    [multiple]="true"
    [clearable]="true"
    [label]="label"
    [bindValue]="bindValue"
    [bindLabel]="bindLabel"
    [addFn]="addFn"
    [removeFn]="removeFn"
    [required]="required"
  >
  </p500-ui-select-field>
</div>
<div class="w100 c-drag-list__container" *ngIf="ctr.value?.length">
  <div cdkDropList (cdkDropListDropped)="drop($event)" class="drag__list">
    <div
      cdkDrag
      [cdkDragDisabled]="dragDisabled"
      *ngFor="let item of ctr.value; index as i; first as isFirst; last as isLast"
      class="c-drag-list__item"
    >
      <div class="d-flex align-items-center">
        <div class="c-term__order-controls">
          <p500-ui-icon [class.disabled]="isFirst" (click)="swap(i, i - 1)" name="arrows-select-up" class="c-term__order-up" size="10px">
          </p500-ui-icon>
          <p500-ui-icon [class.disabled]="isLast" (click)="swap(i, i + 1)" name="arrows-select-down" class="c-term__order-down" size="10px">
          </p500-ui-icon>
        </div>
        <div>
          <ng-container [ngSwitch]="true">
            <ng-container *ngSwitchCase="type === 'arr' && !!bindLabel && !bindValue">{{ item[bindLabel] }}</ng-container>
            <ng-container *ngSwitchCase="type === 'arr' && !!bindLabel && !!bindValue">{{ dataValue[item][bindLabel] }}</ng-container>
            <ng-container *ngSwitchDefault>{{ dataValue?.[item] }}</ng-container>
          </ng-container>
        </div>
      </div>
      <div class="">
        <ng-container *ngFor="let config of checkboxesConfigValue; index as j">
          <div class="c-term__checkbox">
            <p500-ui-checkbox-field [(ngModel)]="checkboxes[j][item]" [label]="config.label"> </p500-ui-checkbox-field>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
